import { UserModel } from '../../../app/modules/auth/models/UserModel'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'

const HasPermission = (pageName: any, scopes: any) => {
    const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
    const role: any = user?.role;
    let permissions = role?.permissions;
    let permissionsObject: any = {}
    permissions.forEach((permission: any) => {
        permissionsObject = {
            ...permissionsObject,
            ...permission
        }
    })
    permissions = permissionsObject[pageName]
    const scopesMap: any = {};
    scopes.forEach((scope: any) => {
        scopesMap[scope] = true;
    });

    return permissions.find((permission: any) => scopesMap[permission]);
};

export default HasPermission